import React from 'react';
import Component from '../../_shared/components/component.js';
import BreadcrumbsContainer from '../../_shared/components/breadcrumbs-container.js';

export default class Post extends Component {
  constructor(props) {
    super(...arguments);
    if(props.match.params.postName !== props.postName) {
      props.fetchPost(props.match.params.postName);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const routePostName = nextProps.match.params.postName;
    const nextPostName = nextProps.postName;
    if(routePostName !== nextPostName) {
      this.props.fetchPost(routePostName);
    }
  }

  render() {
    const CurrentPost = this.props.post;
    return pug`
      div
        BreadcrumbsContainer
        if CurrentPost
          CurrentPost
    `;
  }
}
